import React from 'react';
import styled from 'styled-components';
import { PlaceholderBlock } from '../../styled/placeholders.styled';

const FooterLocationsPlaceholderWrapper = styled.div`
  padding: 0 10px;
`;

export const FooterLocationsPlaceholder = () => (
  <FooterLocationsPlaceholderWrapper>
    <PlaceholderBlock height="15px" borderRadius="4px" margin="10px 0 0" />
    <PlaceholderBlock height="15px" borderRadius="4px" margin="10px 0 0" />
    <PlaceholderBlock height="15px" borderRadius="4px" margin="10px 0 0" />
    <PlaceholderBlock height="15px" borderRadius="4px" margin="10px 0 0" />
    <PlaceholderBlock height="15px" borderRadius="4px" margin="10px 0 0" />
  </FooterLocationsPlaceholderWrapper>
);
